import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import {
  bookingAppointment,
  bookingAvailability,
  getDoctorById,
  getAllUserAppointments,
  updateAppointmentStatus,
  getDoctorAppointmentsById,
  getAllApprovedDoctors, getDoctorAppointmentsByDate,
  getDoctorAppointmentsfilter
} from "../api/api";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { hideLoading, showLoading } from "../redux/spinnerSlice";
import toast from "react-hot-toast";
import { DatePicker, TimePicker, Input, Typography, Table, AutoComplete, Button, Select, Checkbox, Divider, message } from "antd";
import moment from "moment";
import DoctorList from "../components/DoctorList";
import { Flex, Row, Card } from 'antd'; // Import Flex component from Ant Design
const { Option } = Select;
const { Title } = Typography;
const { Search } = Input;

const BookingPage = () => {
  const params = useParams();
  const [doctors, setDoctors] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [appointments, setAppointments] = useState([]);
  const [appointmentss, setAppointmentss] = useState([]);
  const { user } = useSelector((state) => state.user);
  const [mobileNo, setMobileNo] = useState('');
  const [patientName, setPatientName] = useState('');
  const [searchDoctorName, setSearchDoctorName] = useState("");
  const [testName, setTestName] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [mrNo, setmrNo] = useState('');
  const [lastVisit, setLastVisit] = useState('');
  const [doctor, setDoctor] = useState([]);
  const currentDate = moment().startOf('day');
  const formattedDate = currentDate.format('MM-DD-YYYY');
  const [date, setDate] = useState(formattedDate);
  const [filterDate, setFilterDate] = useState('');
  const [time, setTime] = useState();
  const [waitingCheck, setWaitingCheck] = useState(false);
  const [isAvailable, setIsAvailable] = useState(true);
  const [isFlag, setIsFlag] = useState(true);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchMrNo, setSearchMrNo] = useState("");
  const [searchMobileNo, setSeachMobileNo] = useState("");
  const [selectedTime, setSelectedTime] = useState('');
  const [flagMr, setflagMr] = useState('');
  const [selectedDoctorId, setSelectedDoctorId] = useState();
  const [loading, setLoading] = useState(false);
  let availableTimes = null;

  //Fetching doctor
  const fetchDoctorById = async () => {
    try {
      dispatch(showLoading());
      setLoading(true);
      const response = await getDoctorById({ doctorId: params.doctorId });
      setSelectedDoctorId(params.doctorId);
      dispatch(hideLoading());
      setDoctor(response.data);

      setLoading(false);
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);

      setLoading(false);
    }
  };

  const renderAppliedDate = (appliedDate) => {
    if (!appliedDate) {
      return null;
    }
    const momentDate = moment(appliedDate);
    if (!momentDate.isValid()) {
      return null;
    }
    const formattedDate = momentDate.format('DD MMM ,YYYY');// date.toISOString().split('T')[0];

    return formattedDate;
  };
  const disabledDate = (current) =>
    current && current < moment().startOf('day');

  // Generate an array of next 15 days' dates
  const getNext15Days = () => {
    const dates = [];
    const currentDate = moment().startOf('day');
    for (let i = 0; i < 15; i++) {
      dates.push(currentDate.clone().add(i, 'days'));
    }
    return dates;
  };
  const fetchDoctorAppointments = async () => {
    try {
      dispatch(showLoading());

      setLoading(true);
      const doctorId = params.doctorId;

      const today = moment().startOf('day').format("MM-DD-YYYY");
      const res = await getDoctorAppointmentsById(doctorId, today);
      if (res.data.length > 0) {
        setAppointments(res.data);
      } else {
        setAppointments(null);
      }
      dispatch(hideLoading());

      setLoading(false);
    } catch (err) {
      dispatch(hideLoading());

      setLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDoctorAppointments();
    fetchAllApprovedDoctors();
    fetchUserAppointments();
  }, [selectedDoctorId]);
  const fetchAllApprovedDoctors = async () => {
    try {

      setLoading(true);
      dispatch(showLoading());
      const response = await getAllApprovedDoctors();
      setDoctors(response.data);
      dispatch(hideLoading());

      setLoading(false);
    } catch (err) {
      dispatch(hideLoading());

      setLoading(false);
      console.log(err);
    }
  };
  const fetchUserAppointments = async () => {
    try {

      setLoading(true);
      const response = await getAllUserAppointments();
      setAppointmentss(response.data); // Assuming response.data is an array of appointments

      setLoading(false);
    } catch (err) {
      console.error("Error fetching appointments:", err);

      setLoading(false);
    }
  };
  const handleStatus = async (record, status) => {
    try {
      const appointmentsId = record._id;
      const data = { appointmentsId, status };
      dispatch(showLoading());

      setLoading(true);
      const response = await updateAppointmentStatus(data);
      if (response.success) {
        toast.success(response.message);
        fetchDoctorAppointments();
        await fetchUserAppointments();

        setLoading(false);
      }
      dispatch(hideLoading());

      setLoading(false);
    } catch (err) {
      dispatch(hideLoading());

      setLoading(false);
      toast.error(err.response.data.message);
    }
  };
  const generateTimeOptions = () => {
    const options = [];

    let bookedTimes;
    if (appointments.length === 0) {
      if (isFlag) {
        fetchDoctorAppointments();

        setIsFlag(false);
      }
    }
    bookedTimes = appointments?.filter(appointment => appointment.status !== 'rejected' && !appointment.appoinmentType) // Remove rejected appointments and appointments with type true
      .map(appointment => {
        const appointmentTime = new Date(appointment.time);
        const timeString = appointmentTime.toTimeString().substring(0, 5); // Extract hours and minutes as "HH:MM"
        const formattedTime = appointment.time;// appointmentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        return formattedTime;
      });

    for (let hour = 8; hour <= 18; hour++) {
      for (let minute = 0; minute < 60; minute += 20) {
        const formattedHour = hour % 12 || 12;
        const period = hour < 12 ? 'AM' : 'PM';
        const time = `${formattedHour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${period}`;

        const isBooked = bookedTimes.includes(time);
        options.push({ time, isBooked });

      }
    }
    return options;
  };
  const handleTimeChange = (event) => {
    setSelectedTime(event);
    const time = moment(event, "hh:mm A");
    setTime(event)
  };

  const handleDateChange = (value) => {
    const selectedDate = value;//? value?.format("DD-MM-YYYY") : null;
    setDate(selectedDate);
    if (selectedDate) {
      fetchAvailableTimes(selectedDate, selectedDoctorId); // Call backend to get available times
    } else {
      //setAvailableTimes([]); // Reset available times if no date is selected
    }
  };
  const handleDateChanges = (value) => {
    const selectedDate = value?.format("MM-DD-YYYY");
    setDate(selectedDate);
    if (selectedDate) {
      fetchAvailableTimes(selectedDate, selectedDoctorId); // Call backend to get available times
    } else {
      //setAvailableTimes([]); // Reset available times if no date is selected
    }
  };

  const handleFilterDateChanges = async (value) => {
    const selectedDate = value?.format("MM-DD-YYYY");
    try {
      if (selectedDate) {
        setFilterDate(selectedDate);
        dispatch(showLoading());
        let response = null;
        if (searchDoctorName != '') {
          response = await getDoctorAppointmentsByDate({
            doctorId: searchDoctorName,
            date: selectedDate,
          });
        } else {
          response = await getDoctorAppointmentsByDate({
            doctorId: null,
            date: selectedDate,
          });
        }
        dispatch(hideLoading());
        availableTimes = generateTimeOptions();
        if (response.success) {

          setAppointmentss(response.data);
        } else {
          toast.error(response.message);

          setAppointmentss(response.data);
        }
      } else {

        dispatch(showLoading())
        await fetchUserAppointments();

        dispatch(hideLoading())
      }
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };
  const fetchAvailableTimes = async (selectedDate, doctorId) => {
    try {
      dispatch(showLoading());

      setLoading(true);
      const response = await getDoctorAppointmentsByDate({
        doctorId: doctorId,
        date: selectedDate,
      });
      dispatch(hideLoading());

      setLoading(false);

      availableTimes = generateTimeOptions();
      if (response.success) {

        setAppointments(response.data);
      } else {
        toast.error(response.message);

        setAppointments(response.data);
      }
    } catch (err) {
      dispatch(hideLoading());
      availableTimes = null;
      availableTimes = generateTimeOptions();
      toast.error(err.response.data.message);
    }
  };
  const handleBooking = async () => {
    const data = {
      doctorId: params.doctorId,
      userId: user._id,
      doctorInfo: doctor,
      userInfo: user,
      date: date,
      time: time,
      mobileNo: mobileNo,
      pname: patientName,
      testname: testName,
      address: address,
      city: city,
      lastVisit: lastVisit,
      appoinmentType: waitingCheck,
    };
    if (flagMr) {
      data.mrNo = mrNo;
    }
    try {
      dispatch(showLoading());
      const res = await bookingAppointment(data);
      dispatch(hideLoading());
      toast.success(res.message);
      await fetchUserAppointments();
      await fetchAvailableTimes(date, selectedDoctorId);
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };

  //
  const handleAvailability = async () => {
    const data = { doctorId: params.doctorId, date, time };
    try {
      dispatch(showLoading());
      const res = await bookingAvailability(data);
      console.log(res);
      dispatch(hideLoading());
      if (res.success) {
        setIsAvailable(true);
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };

  const handleInputChangeMR = (value, setter, type) => {
    if (setter === setMobileNo) {
      setter(value); // Allow typing only if setter is setMobileNo
    } else {
      setter(value.trim()); // Trim the input value for other setters
    }

    if ((setter === setMobileNo || setter === setPatientName) && value.trim() !== '') {
      const filteredAppointments = appointmentss.filter(appointment =>
        appointment.mobileNo.includes(value) ||
        appointment.mrNo.includes(value) ||
        appointment.pname.toLowerCase().includes(value.toLowerCase())
      );

      setFilteredAppointments(filteredAppointments);

      if (filteredAppointments.length > 0) {
        const firstAppointment = filteredAppointments[0];
        setPatientName(firstAppointment.pname);
        setTestName(firstAppointment.testname);
        setAddress(firstAppointment.address);
        setCity(firstAppointment.city);
        setLastVisit(firstAppointment.date);
        setmrNo(firstAppointment.mrNo);
        setflagMr(true);
      } else {
        setPatientName('');
        setTestName('');
        setAddress('');
        setCity('');
        setLastVisit('');
        setmrNo('');
        setflagMr(false);
      }
    }

    if ((setter === setmrNo || setter === setPatientName || setter === setMobileNo) && value.trim() !== '') {
      const filteredAppointments = appointmentss.filter(appointment =>
        appointment.mrNo.includes(value) ||
        appointment.pname.toLowerCase().includes(value.toLowerCase()) ||
        appointment.mobileNo.includes(value)
      );

      setFilteredAppointments(filteredAppointments);

      if (filteredAppointments.length > 0) {
        const firstAppointment = filteredAppointments[0];
        setMobileNo(firstAppointment.mobileNo);
        setPatientName(firstAppointment.pname);
        setTestName(firstAppointment.testname);
        setAddress(firstAppointment.address);
        setCity(firstAppointment.city);
        setflagMr(true);
        setLastVisit(firstAppointment.date);
      } else {
        // Reset other fields if no matching appointment is found
        setMobileNo('');
        setflagMr(false);
        setPatientName('');
        setTestName('');
        setAddress('');
        setCity('');
        setLastVisit('');
      }
    }
  };

  const handleInputChange = (value, setter, type) => {
    setter(value);
    if (setter === setMobileNo || setter === setPatientName && value.trim() !== '') {
      const filteredAppointments = appointmentss.filter(appointment => appointment.mobileNo.includes(value) || appointment.mrNo.includes(value) || appointment.pname.toLowerCase().includes(value.toLowerCase()));
      setFilteredAppointments(filteredAppointments);
      if (filteredAppointments.length > 0) {
        const firstAppointment = filteredAppointments[0];
        setPatientName(firstAppointment.pname);
        setTestName(firstAppointment.testname);
        setAddress(firstAppointment.address);
        setCity(firstAppointment.city);
        setLastVisit(firstAppointment.date);
        setmrNo(firstAppointment.mrNo);
        setflagMr(true);
      } else {
        setPatientName('');
        setTestName('');
        setAddress('');
        setCity('');
        setLastVisit('');
        setmrNo('');
        setflagMr(false);
      }
    }
    else if (setter === setmrNo || setter === setPatientName || setter === setMobileNo && value.trim() !== '') {
      const filteredAppointments = appointmentss.filter(appointment => appointment.mrNo.includes(value) || appointment.pname.toLowerCase().includes(value.toLowerCase() || appointment.mobileNo.includes(value)));
      setFilteredAppointments(filteredAppointments);
      if (filteredAppointments.length > 0) {
        const firstAppointment = filteredAppointments[0];
        setMobileNo(firstAppointment.mobileNo);
        setPatientName(firstAppointment.pname);
        setTestName(firstAppointment.testname);
        setAddress(firstAppointment.address);
        setCity(firstAppointment.city);
        setflagMr(true);
        setLastVisit(firstAppointment.date);
      } else {
        // Reset other fields if no matching appointment is found
        setMobileNo('');

        setflagMr(false);
        setPatientName('');
        setTestName('');
        setAddress('');
        setCity('');
        setLastVisit('');
      }
    }
  };
  const handleSelectDoctor = (doctorId) => {
    setSelectedDoctorId(doctorId);
    setDate(formattedDate);
    fetchAvailableTimes(formattedDate, doctorId);
  };
  const handleSearchDoctorName = async (value) => {

    setSearchDoctorName(value);

    if (value) {
      try {
        dispatch(showLoading());
        let response;
        if (filterDate != '') {
          response = await getDoctorAppointmentsById(value, filterDate);
        } else { response = await getDoctorAppointmentsById(value, date); }
        if (response.success) {
          setAppointmentss(response.data)
          dispatch(hideLoading());
        } else {

          setAppointmentss(response.data)
          dispatch(hideLoading());
        }
        //  const response = await getDoctorById({ doctorId: value._id });
      } catch (error) {
        dispatch(hideLoading());

        setAppointmentss(null);
        console.error("Error fetching doctor by ID:", error);
      }
    } else {
      dispatch(showLoading())
      await fetchUserAppointments();
      dispatch(hideLoading())
    }
  };

  const handleInputChanges = (e, setter) => {
    setter(e.target.value);
  };
  useEffect(() => {
    fetchDoctorById();
  }, []);

  availableTimes = generateTimeOptions();
  const columns = [
    {
      title: "MR No",
      dataIndex: "mrNo",
      key: "mrNo",
      render: (value) => (
        <span style={{ fontSize: 14, fontWeight: "bold" }}>{value}</span>
      ),
    },
    {
      title: "Doctor Name",
      dataIndex: ["doctorInfo", "firstName"],
      key: "doctorName",
      render: (value) => (
        <span style={{ fontSize: 16, fontWeight: "bold" }}>{value}</span>
      ),
    },

    {
      title: "Patient Name",
      dataIndex: "pname",
      key: "pname",
      render: (value) => (
        <span style={{ fontSize: 20, fontWeight: "bold" }}>{value}</span>
      ),
    },
    {
      title: "Test Name",
      dataIndex: "testname",
      key: "testname",
    },
    {
      title: "Last Visit",
      dataIndex: "lastVisit",
      key: "lastVisit",
      render: renderAppliedDate,//(date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: renderAppliedDate,// (date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (value) => (
        <span style={{ fontSize: 20, fontWeight: "bold" }}>{value}</span>
      ),
      // render: (time) => moment(time, "ddd MMM DD YYYY HH:mm:ss").format("hh:mm A"),
    },
    {
      title: "Appointments Type",
      dataIndex: "appoinmentType",
      key: "appoinmentType",
      render: (value) => (
        <span style={{ color: value ? "red" : "green", fontSize: 18 }}>{value ? "Waiting" : "Confirmed"}</span>
      ),
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNo",
      key: "mobileNo",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Button
          type={text === "APPROVE" ? "success" : text === "PENDING" ? "primary" : "default"}
          style={{
            textTransform: "uppercase",
            color: text === "pending" ? "red" : "green"
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="d-flex">
          {record.status === "pending" && (
            <div className="d-flex">
              <button
                className="btn btn-success mx-2"
                onClick={() => handleStatus(record, "approved")}
              >
                Approved
              </button>
              <button
                className="btn btn-danger"
                onClick={() => handleStatus(record, "rejected")}
              >
                Reject
              </button>
            </div>
          )}
        </div>
      ),
    },
  ];

  const handleReset = async () => {
    await fetchUserAppointments();
    setSearchDoctorName('');
    setFilterDate('');
  }
  const handleSearchByMobileNo = async (e) => {
    setSeachMobileNo(e.target.value);

    setLoading(true);
    try {
      const response = await getDoctorAppointmentsfilter('', e.target.value, '');

      if (response.success) {
        setAppointmentss(response.data);

        setLoading(false);
      } else {
        setAppointmentss([]);

        setLoading(false);
      }
    } catch (error) {

      setLoading(false);
      if (error.response && error.response.status === 404) {
        message.error('Error 404: Resource not found');
        setAppointmentss([]); // Clear the appointments if not found
      } else {

        setLoading(false);
        message.error('An unexpected error occurred:', error);
      }
    }
  };

  const handleSearchByName = async (e) => {
    setSearchName(e.target.value);

    try {

      setLoading(true);
      const response = await getDoctorAppointmentsfilter(e.target.value, '', '');

      if (response.success) {
        setAppointmentss(response.data);

        setLoading(false);
      } else {
        setAppointmentss([]);

        setLoading(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        message.error('Error 404: Resource not found');
        setAppointmentss([]); // Clear the appointments if not found

        setLoading(false);
      } else {
        message.error('An unexpected error occurred:', error);

        setLoading(false);
      }
    }
  };

  const handleSearchmrNo = async (e) => {
    setSearchMrNo(e.target.value);

    try {
      setLoading(true);
      const response = await getDoctorAppointmentsfilter('', '', e.target.value);

      if (response.success) {
        setAppointmentss(response.data);

        setLoading(false);
      } else {
        setAppointmentss([]);

        setLoading(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        message.error('Error 404: Resource not found');
        setAppointmentss([]); // Clear the appointments if not found

        setLoading(false);
      } else {
        message.error('An unexpected error occurred:', error);
        setLoading(false);
      }
    }
  };

  const filteredAppointmentsss = appointmentss?.filter(appointment =>
    appointment.pname.toLowerCase().includes(searchValue.toLowerCase()) ||
    appointment.mobileNo.includes(searchValue) || appointment.mrNo.includes(searchValue)
  );

  const today = new Date();
  const todayAppointments = [];
  const pastAppointments = [];
  const futureAppointments = [];

  filteredAppointmentsss?.forEach(appointment => {
    if (!appointment.date) {
      futureAppointments.push(appointment);
      return;
    }

    const appointmentDate = new Date(appointment.date);
    if (
      appointmentDate.getDate() === today.getDate() &&
      appointmentDate.getMonth() === today.getMonth() &&
      appointmentDate.getFullYear() === today.getFullYear()
    ) {
      todayAppointments.push(appointment);
    } else if (appointmentDate < today) {
      pastAppointments.push(appointment);
    } else {
      futureAppointments.push(appointment);
    }
  });
  todayAppointments.sort((a, b) => {
    const timeA = moment(a.time, "hh:mm A");
    const timeB = moment(b.time, "hh:mm A");
    return timeA - timeB;
  });
  futureAppointments.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateA - dateB;
  });
  const sortedAppointments = [...todayAppointments, ...futureAppointments, ...pastAppointments];



  return (<Layout>
    <Flex direction="column" align="center" justify="center">
      <Card title="Please Select Doctor" style={{ width: '18%', backgroundColor: 'wheat' }}>
        <div >
          {doctors && doctors.map((doctor) =>
            <DoctorList key={doctor._id} doctor={doctor} selectedDoctorId={selectedDoctorId} handleSelectDoctor={handleSelectDoctor} />
          )}
        </div>

      </Card>
      {doctor && (
        <div className="card mt-3" style={{ left: '2%', width: '80%' }}>
          <div className="card-body">
            <div className="d-flex flex-column">
              <div className="d-flex flex-wrap mb-2">
                {getNext15Days().map((day) => (
                  <button
                    key={day.format("MM-DD-YYYY")}
                    onChange={handleDateChange}
                    className={`btn btn-outline-secondary mx-1 mb-1 ${date === day.format("MM-DD-YYYY") ? "active" : ""}`}
                    onClick={() => {
                      setDate(day?.format("MM-DD-YYYY"));
                      handleDateChange(day?.format("MM-DD-YYYY"));
                    }}

                  >
                    {day.format("MM-DD-YYYY")}
                  </button>

                ))}
                <DatePicker
                  aria-required={"true"}
                  className="mb-2"
                  format={"MM-DD-YYYY"}
                  onChange={handleDateChanges}
                  disabledDate={disabledDate}
                />
              </div>
              <Flex></Flex>
              <AutoComplete className="mb-2"
                aria-required={"true"}
                placeholder="Search Mr No"
                value={mrNo}
                onChange={(value) => handleInputChangeMR(value, setmrNo)}
              >
                {filteredAppointments.map(appointment => (
                  <AutoComplete.Option key={appointment._id} value={appointment.mrNo}>
                    {`${appointment.mrNo} - ${appointment.mobileNo} - ${appointment.pname}`}
                  </AutoComplete.Option>
                ))}
              </AutoComplete>
              <AutoComplete className="mb-2"
                aria-required={"true"}
                placeholder="Enter Mobile No"
                value={mobileNo}
                onChange={(value) => handleInputChange(value, setMobileNo)}
              >
                {filteredAppointments.map(appointment => (
                  <AutoComplete.Option key={appointment._id} value={appointment.mobileNo}>
                    {`${appointment.mobileNo} - ${appointment.pname}`}
                  </AutoComplete.Option>
                ))}
              </AutoComplete>
              <Input
                aria-required={"true"}
                type="text"
                className="mb-2"
                placeholder="Patient Name"
                value={patientName}
                onChange={(e) => handleInputChanges(e, setPatientName)}
              ></Input>

              <hr></hr>
              <Checkbox
                checked={waitingCheck}
                onChange={(e) => {
                  const newValue = e.target.checked; // Provide a default value here if needed
                  setWaitingCheck(newValue);
                }}
              >
                Waiting Check
              </Checkbox>

              <hr></hr>
              <Input
                aria-required={"true"}
                type="text"
                className="mb-2"
                placeholder="Test Name"
                value={testName}
                onChange={(e) => handleInputChanges(e, setTestName)}
              ></Input>
              {/* <Input
                  aria-required={"true"}
                  type="text"
                  className="mb-2"
                  placeholder="Address"
                  value={address}
                  onChange={(e) => handleInputChanges(e, setAddress)}
                ></Input>
                <Input
                  aria-required={"true"}
                  type="text"
                  className="mb-2"
                  placeholder="City"
                  value={city}
                  onChange={(e) => handleInputChanges(e, setCity)}
                ></Input> */}
              <Input
                aria-required={"true"}
                type="text"
                className="mb-2"
                placeholder="Last Visit"
                value={lastVisit}
                onChange={(e) => handleInputChanges(e, setLastVisit)}
              ></Input>
              {/* <DatePicker
                  aria-required={"true"}
                  className="mb-2"
                  format={"DD-MM-YYYY"}
                  onChange={(value) => setDate(value.format("DD-MM-YYYY"))}
                  disabledDate={(current) =>
                    current && current < moment().startOf("day")
                  }
                /> */}

              <label htmlFor="timeSelect">Select a time</label>
              <hr></hr>
              <div className="d-flex flex-wrap mb-2">
                {availableTimes.map(({ time, isBooked }) => (
                  <button
                    key={time}
                    className={`btn btn-outline-secondary mx-1 mb-1 ${selectedTime === time ? "active" : ""
                      } ${isBooked ? "booked" : ""}`}
                    style={{ backgroundColor: selectedTime === time ? 'blue' : isBooked ? 'red' : 'transparent', color: selectedTime === time || isBooked ? 'white' : 'black' }}
                    onClick={() => handleTimeChange(time)}
                  >
                    {time}
                  </button>
                ))}
              </div>

              {/* <button
                  className="btn btn-primary"
                  onClick={handleAvailability}
                >
                  Check Availability
                </button> */}

              {isAvailable && (
                <button
                  className="btn btn-success mt-2"
                  onClick={handleBooking}
                >
                  Book Now
                </button>
              )}
            </div>

          </div>
        </div>
      )}
      {/* </div> */}
    </Flex>
    <hr></hr>

    <Divider dashed orientation="left">
      <Search
        placeholder="Search by MR NO"
        value={searchMrNo}
        onChange={handleSearchmrNo}
        style={{ width: 300, marginBottom: 16, marginLeft: '1%', backgroundColor: "yellow" }}
      />
      <Search
        placeholder="Search by Mobile No"
        value={searchMobileNo}
        onChange={handleSearchByMobileNo}
        style={{ width: 300, marginBottom: 16, marginLeft: '1%', backgroundColor: "yellow" }}
      />
      <Search
        placeholder="Search by name"
        value={searchName}
        onChange={handleSearchByName}
        style={{ width: 300, marginBottom: 16, marginLeft: '1%', backgroundColor: "yellow" }}
      />
      <DatePicker style={{ marginLeft: '1%' }}
        className="mb-2"
        format={"MM-DD-YYYY"}
        onChange={handleFilterDateChanges}
      />
      <Select defaultValue="Select an option" value={searchDoctorName} style={{ width: 200, marginLeft: '2%' }} onChange={handleSearchDoctorName}>
        <Option value="">Select an option</Option>
        {doctors?.map(option => (
          <Option key={option._id} value={option._id}>
            {option.firstName}
          </Option>
        ))}
      </Select>

      <Button type="primary" style={{ marginLeft: '1%' }} onClick={handleReset}>Reset</Button>
    </Divider>
    <Table dataSource={sortedAppointments} loading={loading} columns={columns} pagination={false} pagesize={100} />
  </Layout>

  );
};

export default BookingPage;
